import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  DrawerContext,
  FilterChip,
  IconRegularClose,
} from '@notino/react-styleguide';
import { WishlistSortBy } from '@notino/shared/definitions/types';

import { useWishlistStore } from '@containers/WishList/store';

import { DrawerTitle } from '../DrawerTitle';
import messages from '../messages';

import { SortByOptionsList } from './SortByOptionsList';

export const SortingChip = () => {
  const { setSelectedSortBy } = useWishlistStore((x) => x.actions);
  const selectedSortBy = useWishlistStore((x) => x.selectedSortBy);
  const sortByOptions = useWishlistStore((x) => x.sortByOptions);
  const { openDrawer, closeDrawer } = DrawerContext.useDrawerContext();

  const sortActive = selectedSortBy !== WishlistSortBy.Default;

  const openSortingDrawer = () => {
    openDrawer(<SortByOptionsList />, {
      title: (
        <DrawerTitle
          name={<FormattedMessage {...messages.sorting} />}
          onRefreshButtonClick={() => {
            setSelectedSortBy(WishlistSortBy.Default);
            closeDrawer();
          }}
        />
      ),
      showCloseIcon: false,
      showFade: true,
      isTitleBorderHidden: true,
      allowResize: false,
      hideScrollbar: true,
    });
  };

  return (
    <FilterChip
      title={
        sortActive ? (
          sortByOptions.find((x) => x.sortBy === selectedSortBy)?.name ?? ''
        ) : (
          <FormattedMessage {...messages.sorting} />
        )
      }
      isActive={sortActive}
      onClick={openSortingDrawer}
      secondaryIcon={<IconRegularClose width="16px" height="16px" />}
      onSecondaryIconClick={
        sortActive ? () => setSelectedSortBy(WishlistSortBy.Default) : undefined
      }
    />
  );
};
